// extracted by mini-css-extract-plugin
export default {"daysCover":"styles_daysCover__jxGLi","daysCover__item":"styles_daysCover__item__34DER"};